module.exports = __webpack_public_path__ + "img/love-bonito.dfe7b956.svg";